// extracted by mini-css-extract-plugin
module.exports = {"root":"DiscountForm_root__1cz3M","icon":"DiscountForm_icon__3Ri-q","heading":"DiscountForm_heading__28q6i","field":"DiscountForm_field__2BqY1","error":"DiscountForm_error__1DNgv"};